import React from 'react';
import styles from './PagePanel.module.scss';

const PagePanel = ({ children }) => {
  return <div className={styles.pagePanel}>{children}</div>;
};

export default PagePanel;
